import { render, staticRenderFns } from "./allDetail.vue?vue&type=template&id=b70a6940&scoped=true"
import script from "./allDetail.vue?vue&type=script&lang=js"
export * from "./allDetail.vue?vue&type=script&lang=js"
import style0 from "./mixins/detailLayout.scss?vue&type=style&index=0&id=b70a6940&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a6940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b70a6940')) {
      api.createRecord('b70a6940', component.options)
    } else {
      api.reload('b70a6940', component.options)
    }
    module.hot.accept("./allDetail.vue?vue&type=template&id=b70a6940&scoped=true", function () {
      api.rerender('b70a6940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalList/allDetail.vue"
export default component.exports